module.exports = __webpack_public_path__ + "static/media/h-square.ce504fb6.svg";